export var TakeoverEnum;
(function (TakeoverEnum) {
    TakeoverEnum["TravelWalletTakeover"] = "TravelWalletTakeover";
    TakeoverEnum["StatusTakeover"] = "StatusTakeover";
})(TakeoverEnum || (TakeoverEnum = {}));
//# sourceMappingURL=takeovers.js.map